// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"ff777888","412":"0f30017e","920":"d8cb30ff"}[chunkId] + ".chunk.js";
};